import axios from 'axios';
import store from '../../store';
import router from '../../router';

axios.interceptors.request.use(function(config) {
    const token = localStorage.getItem("token");
    if(token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, function(err) {
    
    return Promise.reject(err);
});

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            if (error.response.status === 403 || error.response.status === 401) {
                // Redirect to login page
                localStorage.removeItem("token");
                store.commit("vaciarDatosSession");
                router.push("/Login");
            }
        }
        return Promise.reject(error)
    },
);